<template  >
  <div :class="div_class">
    <router-link v-bind:to="linkTo"  v-if="isEnable" >
    <button type="button"  :class="'btn btn-lg btn-primary menu-btn menu-btn-enabled ' + btn_class " v-html='btnText' ></button>
    </router-link>
    <button type="button"  disabled="disabled" class="btn btn-lg btn-default menu-btn menu-btn-disabled" v-else="isEnable"  v-html='btnText'></button>
  </div>
</template>

<script>

export default {
  computed: {
    btnText () {
      var comp = ""
      if(typeof this.$props.textb != "undefined"){
        if(this.$props.textb.length > 0){
          comp = "<br>" + this.$props.textb
        }
      }
      return "" + this.$props.text + comp
    },

    linkTo  () {
      return this.$props.link || 'menu'
    },
    isEnable () {
      return this.$props.enabled === 'true'
    },
    div_class () {
      if(this.$props.is_full === true){
        return 'col-xs-12 menu-container'
      }else{
        return 'col-xs-6 menu-container'
      }
    }
  },
  props: ['link', 'enabled', 'text','textb','is_full','btn_class']
}
</script>
<style scoped>
.menu-btn {
  
  font-size: 14px;
  width: 80%;
  white-space: normal;
  height: 60px;
}
.menu-container {
  padding: 5px 5px 15px 5px;
  
}
.menu-btn-enabled{

}
.menu-btn-disabled{
background:#ccc;
}
.white_btn{
        background: white;
    color: #337ab6;
}
.white_btn:hover{
    background: #337ab61f;

}
</style>



// WEBPACK FOOTER //
// menu-btn.vue?4ff915da